import { Component, computed, input } from '@angular/core'
import { environment } from '@env'
import { SafePipe } from '@performance/ui'
import { LazyImgDirective } from '@shared/directives/lazy-img.directive'

@Component({
  selector: 'mcp-ball-spinner',
  templateUrl: './ball-spinner.html',
  styleUrls: ['./ball-spinner.scss'],
  imports: [LazyImgDirective, SafePipe],
})
export class BallSpinner {
  readonly urlLoaderImg = environment.staticsUrlAssets + 'img/portal/loader_ball.gif'

  readonly extraClasses = input<string>(undefined)

  readonly className = computed(() => ['c-loading', this.extraClasses()].filter(Boolean).join(' '))
}
